import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccountComponent from '../../components/Account';
import {
  setPasswordRequest,
  validateDOBRequest,
  resetPasswordRequest,
  migrateToPasswordRequest,
  changePasswordRequest,
  changeSecurityRequest,
  setNationalityAndLanguageRequest,
} from '../../actionCreators/account';

import { TRUST_HANDBOOK_SUCCESS } from '../../constants/actionTypes';

const Account = (props) => <AccountComponent {...props} />;

const AccountContainer = (props) => {
  const state = useSelector((state) => ({
    account: state.account,
    currentUser: state.currentUser,
    customAppId: state.customApp.id,
  }));

  const dispatch = useDispatch();

  const actions = {
    setPassword: (payload) => dispatch(setPasswordRequest(payload)),
    changePassword: (payload) => dispatch(changePasswordRequest(payload)),
    validateDOB: (payload) => dispatch(validateDOBRequest(payload)),
    resetPassword: (payload) => dispatch(resetPasswordRequest(payload)),
    migrateToPassword: (payload) => dispatch(migrateToPasswordRequest(payload)),
    changeSecurity: (payload) => dispatch(changeSecurityRequest(payload)),
    changeNationalityAndLanguage: (payload) => dispatch(setNationalityAndLanguageRequest(payload)),
    onAcceptTrustHandbook: () =>
        dispatch({
          type: TRUST_HANDBOOK_SUCCESS,
          payload: { setPassword: true }
        }),
  };

  return <Account {...props} {...state} {...actions} />;
};

export default AccountContainer;
